import syntax from "../assets/syntax-h.svg";
import focus from "../assets/focus-e.svg";



const featuresDetails = [
  {
    icon: syntax,
    title: "Elegant &  Dark",
    description: "Enjoy a visually appealing dark color scheme that creates a comfortable coding environment."
  },
  {
    icon: syntax,
    title: "Enhanced Readability",
    description: "Carefully chosen colors ensure clear visibility and easy-to-read text."
  },
  {
    icon: syntax,
    title: "Syntax Highlighting",
    description: "The theme provides consistent and aesthetically pleasing syntax highlighting for various programming languages"
  },
  {
    icon: focus,
    title: "Focused Editing",
    description: "The theme's subtle design elements help keep your focus on the code and minimize distractions."
  },
  {
    icon: focus,
    title: "Markdown  Support",
    description: "The theme also supports markdown files and other files like ignore file types ie. .gitignore, .vscodeignore etc."
  }
];

export default featuresDetails;